/* eslint-disable no-param-reassign,no-underscore-dangle,@typescript-eslint/no-use-before-define,no-var,vars-on-top */

import { difference } from 'lodash';
import { selectFormValidationData } from '../../../app/common/validators/store/validators.selectors';

xplenty.directive('formListener', [
  'ngrxStoreService',

  function (ngrxStoreService) {
    return {
      restrict: 'A',

      require: '?form',

      priority: 10,

      link: {
        post(scope, element, attrs, form) {
          let previousKeys = [];

          const subscription = ngrxStoreService.pipe(selectFormValidationData(form.$name)).subscribe((formData) => {
            Object.keys(formData)
              .filter((key) => formData[key] != null)
              .forEach((key) => {
                const formField = form[key];

                if (formField) {
                  form[key].$setValidity(key, formData[key]);
                }
              });
            difference(previousKeys, Object.keys(formData))
              .filter((key) => form[key])
              .forEach((key) => {
                form[key].$setValidity(key, true);
              });

            previousKeys = Object.keys(formData);

            if (scope.isComponentValid) {
              scope.isComponentValid();
            }
          });

          scope.$on('$destroy', () => {
            if (subscription) {
              subscription.unsubscribe();
            }
          });
        },
      },
    };
  },
]);
